import { isPlatformBrowser } from '@angular/common';
import { inject, PLATFORM_ID } from '@angular/core';
import { MarketingAttributionService } from '../services/analytics/marketing-attribution.service';

/**
 * APP_INITIALIZER factory that captures Google Ads click ids (gclid / wbraid /
 * gbraid) from the landing URL as early as possible — before any client-side
 * redirect or SPA reroute can strip the query string (browser only).
 */
export function initializeMarketingAttribution(): () => void {
  const attribution = inject(MarketingAttributionService);
  const platformId = inject(PLATFORM_ID);

  return () => {
    if (isPlatformBrowser(platformId)) {
      attribution.captureFromUrl();
    }
  };
}
